import { aboutData } from "@/mocks/about";

export default function Testimonials() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-500/20 text-secondary-300 rounded-full mb-4">
            用户口碑
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-50 leading-tight">
            吃瓜群众<br />怎么说
          </h2>
        </div>

        <div className="columns-1 md:columns-3 gap-5 md:gap-6">
          {aboutData.testimonials.map((t) => (
            <div
              key={t.id}
              className="break-inside-avoid mb-5 md:mb-6 bg-background-200/60 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-background-300 overflow-hidden flex-shrink-0">
                  <img
                    src={t.avatarUrl}
                    alt={t.name}
                    title={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-100">
                    {t.name}
                  </p>
                  <p className="text-xs text-foreground-600">{t.username}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed italic">
                &ldquo;{t.quote}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}